import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal = _resolveComponent("app-modal")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_app_modal, {
      title: _ctx.$t('ex.leave.title'),
      content: _ctx.$t('ex.leave.content'),
      dismiss: _ctx.cancelHandler,
      actions: [
        {
          label: _ctx.$t('common.yes'),
          handler: _ctx.confirmHandler,
        },
        {
          label: _ctx.$t('common.no'),
          handler: _ctx.cancelHandler,
        },
      ]
    }, null, 8, ["title", "content", "dismiss", "actions"])
  ]))
}